module.exports = __webpack_public_path__ + "static/media/logo.54761789.png";